<template>
  <div>
    <el-breadcrumb separator-icon="ArrowRight" style="margin: 16px">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>信息管理</el-breadcrumb-item>
      <el-breadcrumb-item>班级管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card style="margin: 15px; min-height: calc(100vh - 111px)">
      <div>
        <!--    功能区-->
        <div style="margin: 10px 0">
          <!--    搜索区-->
          <div style="margin: 10px 0">
            <el-input v-model="search" clearable placeholder="请输入班级名称" prefix-icon="Search" style="width: 15%" />
            <el-button icon="Search" style="margin-left: 5px" type="primary" @click="load"></el-button>
            <el-button icon="refresh-left" style="margin-left: 10px" type="default" @click="reset"></el-button>
            <div style="float: right; display: flex; align-items: center; gap: 10px;">
              <el-tooltip content="Excel导入" placement="top">
                <el-button icon="Upload" type="warning" @click="handleImport">导入</el-button>
              </el-tooltip>
              <el-tooltip content="Excel导出" placement="top">
                <el-button icon="Download" type="success" @click="handleExport">导出</el-button>
              </el-tooltip>
              <el-tooltip content="添加" placement="top">
                <el-button icon="plus" style="width: 50px" type="primary" @click="add"></el-button>
              </el-tooltip>
            </div>
          </div>
        </div>

        <!-- 退房提醒卡片 -->
        <el-row :gutter="20" style="margin: 15px 0">
          <el-col :span="6">
            <el-card shadow="hover" :body-style="{ padding: '10px' }">
              <div style="display: flex; align-items: center;">
                <el-icon color="#67C23A" size="24"><Calendar /></el-icon>
                <div style="margin-left: 10px;">
                  <div style="font-size: 12px; color: #909399;">今日入住</div>
                  <div style="font-size: 20px; font-weight: bold;">{{ reminders.todayCheckin || 0 }}</div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="hover" :body-style="{ padding: '10px' }">
              <div style="display: flex; align-items: center;">
                <el-icon color="#F56C6C" size="24"><AlarmClock /></el-icon>
                <div style="margin-left: 10px;">
                  <div style="font-size: 12px; color: #909399;">今日退房</div>
                  <div style="font-size: 20px; font-weight: bold;">{{ reminders.todayCheckout || 0 }}</div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="hover" :body-style="{ padding: '10px' }">
              <div style="display: flex; align-items: center;">
                <el-icon color="#E6A23C" size="24"><Timer /></el-icon>
                <div style="margin-left: 10px;">
                  <div style="font-size: 12px; color: #909399;">明日退房</div>
                  <div style="font-size: 20px; font-weight: bold;">{{ reminders.tomorrowCheckout || 0 }}</div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="hover" :body-style="{ padding: '10px' }">
              <div style="display: flex; align-items: center;">
                <el-icon color="#409EFF" size="24"><Calendar /></el-icon>
                <div style="margin-left: 10px;">
                  <div style="font-size: 12px; color: #909399;">本周退房</div>
                  <div style="font-size: 20px; font-weight: bold;">{{ reminders.weekCheckout || 0 }}</div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>

        <!--    表格-->
        <el-table v-loading="loading" :data="tableData" border max-height="550" style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" />
          <el-table-column label="班级名称" prop="className" sortable />
          <el-table-column label="入住日期" prop="startDate" sortable />
          <el-table-column label="离校日期" prop="endDate" sortable />
          <el-table-column label="颜色标记" width="120px">
            <template #default="scope">
              <div :style="{ width: '30px', height: '30px', backgroundColor: scope.row.colorTag || '#ffffff', borderRadius: '4px', border: '1px solid #dcdfe6' }"></div>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="120px">
            <template #default="scope">
              <el-tag v-if="scope.row.status === 1" type="success">进行中</el-tag>
              <el-tag v-else-if="scope.row.status === 0" type="info">已结业</el-tag>
              <el-tag v-else type="warning">{{ scope.row.status }}</el-tag>
            </template>
          </el-table-column>
          <!--      操作栏-->
          <el-table-column label="操作" width="200px">
            <template #default="scope">
              <el-button icon="Edit" type="primary" @click="handleEdit(scope.row)"></el-button>
              <el-button v-if="scope.row.status === 0" icon="Delete" type="danger" @click="handleBatchDelete(scope.row)"></el-button>
              <el-popconfirm title="确认删除？" @confirm="handleDelete(scope.row.id)">
                <template #reference>
                  <el-button icon="Delete" type="danger"></el-button>
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>

        <!-- 批量操作 -->
        <div v-show="multipleSelection.length > 0" style="margin: 10px 0;">
          <el-button type="danger" @click="handleBatchDeleteSelection">批量删除（结业）</el-button>
        </div>

        <!--分页-->
        <div style="margin: 10px 0">
          <el-pagination v-model:currentPage="currentPage" :page-size="pageSize" :page-sizes="[10, 20]" :total="total"
            layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange">
          </el-pagination>
        </div>

        <!--      弹窗-->
        <div>
          <el-dialog v-model="dialogVisible" :title="judge ? '编辑班级' : '添加班级'" width="30%" @close="cancel">
            <el-form ref="form" :model="form" :rules="rules" label-width="120px">
              <el-form-item label="班级名称" prop="className">
                <el-input v-model="form.className" style="width: 80%"></el-input>
              </el-form-item>
              <el-form-item label="入住日期" prop="startDate">
                <el-date-picker v-model="form.startDate" type="date" placeholder="选择入住日期" style="width: 80%" value-format="YYYY-MM-DD"></el-date-picker>
              </el-form-item>
              <el-form-item label="离校日期" prop="endDate">
                <el-date-picker v-model="form.endDate" type="date" placeholder="选择离校日期" style="width: 80%" value-format="YYYY-MM-DD"></el-date-picker>
              </el-form-item>
              <el-form-item label="颜色标记" prop="colorTag">
                <div class="class-color-picker">
                  <div v-for="opt in classColorOptions" :key="opt.color"
                    class="class-color-option"
                    :class="{ 'class-color-active': form.colorTag === opt.color }"
                    :style="{ backgroundColor: opt.color }"
                    @click="form.colorTag = opt.color"
                    :title="opt.label">
                    <el-icon v-if="form.colorTag === opt.color" size="14" color="#fff"><Check /></el-icon>
                  </div>
                </div>
              </el-form-item>
            </el-form>
            <template #footer>
              <span class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
              </span>
            </template>
          </el-dialog>

          <!-- 导入弹窗 -->
          <el-dialog v-model="importDialogVisible" title="导入班级学员" width="30%" @close="cancelImport">
            <div style="margin-bottom: 15px;">
              <el-button type="success" icon="Download" @click="downloadTemplate">下载导入模板</el-button>
            </div>
            <el-upload
              ref="uploadRef"
              action=""
              :auto-upload="false"
              :on-change="handleFileChange"
              :limit="1"
              accept=".xlsx,.xls"
            >
              <el-button type="primary">选择Excel文件</el-button>
              <template #tip>
                <div style="margin-top: 10px; color: #909399;">支持 .xlsx 或 .xls 格式，系统会自动按姓名+手机号查重</div>
              </template>
            </el-upload>
            <template #footer>
              <span class="dialog-footer">
                <el-button @click="cancelImport">取 消</el-button>
                <el-button type="primary" @click="confirmImport">确 定</el-button>
              </span>
            </template>
          </el-dialog>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script src="@/assets/js/ClassInfo.js"></script>
<style scoped>
@import '../assets/css/ClassInfo.css';

.class-color-picker {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.class-color-option {
  width: 36px;
  height: 28px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid transparent;
  transition: all 0.2s;
}

.class-color-option:hover {
  transform: scale(1.1);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.class-color-active {
  border: 2px solid #333;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}
</style>
